import { render } from "./SingleGameOver.vue?vue&type=template&id=6861e48a&scoped=true"
import script from "./SingleGameOver.vue?vue&type=script&lang=js"
export * from "./SingleGameOver.vue?vue&type=script&lang=js"

import "./SingleGameOver.vue?vue&type=style&index=0&id=6861e48a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6861e48a"]])

export default __exports__